import React from 'react';

const r = (Component, renderBool = true, profile = undefined) => function rp(props) {
  if (!renderBool) return null;
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Component {...props} profile={profile} />;
};

export default r;
